/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/InboxAppInsights"/>

import { trackEvent } from 'Core/Medius.Core.Web/Scripts/appInsights';
import { getTenantId } from 'Core/Medius.Core.Web/Scripts/Medius/lib/path';
import { getGlobalId } from 'Core/Medius.Core.Web/Scripts/Medius/lib/utils/user';
import { newGuid } from 'Core/Medius.Core.Web/Scripts/lib/uniqueGuid';

let sessionId: string | null = null;

export enum InboxEventType {
    ToggleToNew = 'NewSupplierInbox_ToggleToNew',
    ToggleBackToOld = 'NewSupplierInbox_ToggleBackToOld',
    SessionStart = 'NewSupplierInbox_SessionStart',
    SessionEnd = 'NewSupplierInbox_SessionEnd',
    DocumentOpened = 'NewSupplierInbox_DocumentOpened',
    DocumentAction = 'NewSupplierInbox_DocumentAction',
    FilterApplied = 'NewSupplierInbox_FilterApplied',
    SavedViewCreated = 'NewSupplierInbox_SavedViewCreated',
    TabSwitch = 'NewSupplierInbox_TabSwitch'
}

interface InboxEventProperties {
    TenantId: string;
    userGlobalId: string;
    [key: string]: any;
}

function getBaseProperties(): InboxEventProperties {
    return {
        TenantId: getTenantId(),
        userGlobalId: getGlobalId()
    };
}

export function trackToggleToNew(): void {
    trackEvent({
        name: InboxEventType.ToggleToNew,
        properties: {
            ...getBaseProperties()
        }
    });
}

export function trackToggleBackToOld(): void {
    trackEvent({
        name: InboxEventType.ToggleBackToOld,
        properties: {
            ...getBaseProperties()
        }
    });
}

export function trackSessionStart(): void {
    trackSessionEnd();
    sessionId = newGuid();
    trackEvent({
        name: InboxEventType.SessionStart,
        properties: {
            ...getBaseProperties(),
            sessionId: sessionId
        }
    });
}

export function trackSessionEnd(): void {
    if (sessionId) {
        trackEvent({
            name: InboxEventType.SessionEnd,
            properties: {
                ...getBaseProperties(),
                sessionId: sessionId
            }
        });
    }
    sessionId = null;
}

export function trackDocumentOpened(documentId: number): void {
    if (sessionId) {
        trackEvent({
            name: InboxEventType.DocumentOpened,
            properties: {
                ...getBaseProperties(),
                sessionId: sessionId,
                documentId: documentId
            }
        });
    }
}

export function trackDocumentAction(documentId: number): void {
    if (sessionId) {
        trackEvent({
            name: InboxEventType.DocumentAction,
            properties: {
                ...getBaseProperties(),
                sessionId: sessionId,
                documentId: documentId
            }
        });
    }
}

export function trackFilterApplied(appliedFilterNames: string[]): void {
    if (sessionId) {
        appliedFilterNames.forEach(filterName => {
            trackEvent({
                name: InboxEventType.FilterApplied,
                properties: {
                    ...getBaseProperties(),
                    sessionId: sessionId,
                    filterName: filterName
                }
            });
        });
    }
}

export function trackSavedViewCreated(viewName: string): void {
    if (sessionId) {
        trackEvent({
            name: InboxEventType.SavedViewCreated,
            properties: {
                ...getBaseProperties(),
                sessionId: sessionId,
                viewName: viewName
            }
        });
    }
}

export function trackTabSwitch(fromTab: string, toTab: string): void {
    if (sessionId) {
        trackEvent({
            name: InboxEventType.TabSwitch,
            properties: {
                ...getBaseProperties(),
                sessionId: sessionId,
                fromTab: fromTab,
                toTab: toTab
            }
        });
    }
}
